import { memo } from 'react';
import { formatTime } from '@src/utils';
import useTimer from './useTimer';
import { GiSandsOfTime } from 'react-icons/gi';
import { OTooltip } from '@src/shared';
import './timer.scss';

interface IProps {
  referenceTime: number;
  duration: string;
  title?: string;
  onTimeFinish: () => void;
}

const Timer = ({ referenceTime, duration, title, onTimeFinish }: IProps) => {
  const { timeLeft } = useTimer({ referenceTime, duration, onTimeFinish });

  return (
    <OTooltip title={title || ''}>
      <div className={`timer-box ${!timeLeft ? 'finished' : ''}`}>
        {timeLeft > 0 && <GiSandsOfTime height={20} />}
        <span>{timeLeft > 0 ? formatTime(timeLeft) : 'ended'}</span>
      </div>
    </OTooltip>
  );
};

export default memo(Timer);
